import { Component, OnInit, inject, OnDestroy, AfterViewInit } from '@angular/core';
import { RouterOutlet, Router, NavigationEnd } from '@angular/router';
import { ToastComponent } from './@shared/components';
import { AuthService } from './@core/authentication/services';
import { NavigationPreventionService } from './@core/services';
import { filter, take } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ToastComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy {
  private readonly authService = inject(AuthService);
  private readonly navigationPreventionService = inject(NavigationPreventionService);
  private readonly router = inject(Router);

  ngOnInit() {
    // Only fetch CSRF token if user is already authenticated
    if (this.authService.isAuthenticated()) {
      this.authService.fetchCsrfToken().subscribe({
        next: () => console.log('✅ CSRF token initialized'),
        error: (err) => console.warn('⚠️  CSRF token fetch failed (non-critical):', err)
      });
    }
  }

  ngAfterViewInit() {
    // Wait for initial navigation to complete before enabling prevention
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        take(1)
      )
      .subscribe(() => {
        // Enable browser navigation prevention after initial route is loaded
        // Set preventPageUnload to true if you also want to prevent page refresh/close
        this.navigationPreventionService.enable(false);
        console.log('🚫 Browser navigation prevention enabled');
      });
  }

  ngOnDestroy() {
    // Disable navigation prevention when component is destroyed
    this.navigationPreventionService.disable();
  }
}
